import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

const CheckBox = (props) => (
  <Checkbox {...props} />
);

export default CheckBox;